// Bileli · i18n — Kyrgyz for the shared chrome: header/nav, profile, spaces, widgets, shared UI.
// Keyed by the exact Russian source string (see index.ts). Identical-in-Kyrgyz strings are deliberately
// OMITTED (t() falls back to the key): Каталог, Профиль, Тема, Рекорд, МБ, Авто, Пауза, Курсив.
export const KY_COMMON: Record<string, string> = {
  // App header nav (BileliAppHeader)
  Главная: 'Башкы',
  'Мои курсы': 'Менин курстарым',
  Курсы: 'Курстар',
  Сообщества: 'Коомчулуктар',

  // Username nudge (UsernameNudge)
  'Укажите @имя-пользователя в Telegram.': 'Telegram\'да @колдонуучу-атыңызды көрсөтүңүз.',
  'Ученики смогут написать вам напрямую из вопросов к урокам — без юзернейма кнопка связи не работает.':
    'Окуучулар сабактарга берилген суроолордон сизге түз жаза алышат — юзернейм жок болсо байланыш баскычы иштебейт.',
  'Преподаватель сможет ответить вам лично, когда вы зададите вопрос к уроку.':
    'Сабакка суроо бергениңизде мугалим сизге жеке жооп бере алат.',
  'Обновляем ваш @username…': '@username жаңыртылууда…',
  'Указать юзернейм': 'Юзернейм көрсөтүү',
  Позже: 'Кийин',

  // Profile (ProfilePanel / useProfile)
  'Профиль загружается…': 'Профиль жүктөлүүдө…',
  Учёба: 'Окуу',
  Преподавание: 'Окутуу',
  Уровень: 'Деңгээл',
  'XP до следующего': 'XP кийинки деңгээлге чейин',
  'дн. подряд': 'күн удаа',
  'дн.': 'күн',
  'Язык интерфейса': 'Интерфейс тили',
  Тёмная: 'Караңгы',
  Светлая: 'Жарык',
  'Профиль и фото в Telegram': 'Telegram\'дагы профиль жана сүрөт',
  'Язык Telegram (кыргызча пакети — в списке)': 'Telegram тили (кыргызча пакети — тизмеде)',
  'Ваше имя': 'Атыңыз',
  'сохраняю…': 'сакталууда…',
  'Введите настоящее имя (не только эмодзи).': 'Чыныгы атыңызды жазыңыз (эмодзи гана эмес).',
  'Не удалось сохранить имя.': 'Аты сакталган жок.',
  'Обновить фото из Telegram': 'Telegram\'дан сүрөттү жаңылоо',
  'Добавить фото в Telegram': 'Telegram\'га сүрөт кошуу',
  'Обновляем…': 'Жаңыртылууда…',
  'Удалить фото': 'Сүрөттү өчүрүү',
  'Не удалось получить фото из Telegram.': 'Telegram\'дан сүрөттү алуу мүмкүн болгон жок.',
  'Не удалось удалить фото.': 'Сүрөттү өчүрүү мүмкүн болгон жок.',

  // Spaces (SpacesPanel badges + copy)
  'в очереди': 'кезекте',
  'создаём…': 'түзүлүүдө…',
  готово: 'даяр',
  ошибка: 'ката',
  'занято другим воркером — возможен «осиротевший» форум, проверьте вручную':
    'башка воркер ээлеп алган — «ээсиз» форум калышы мүмкүн, кол менен текшериңиз',
  ['Создаёт форум-группу для каждого вашего опубликованного потока: темы «Жарыялар» (закрытая) '
    + 'и «Талкуу», бот-админ, вход по заявке. Группы создаются от имени текущего Telegram-аккаунта '
    + 'и появляются в его списке чатов.']:
    'Ар бир жарыяланган агымыңыз үчүн форум-группа түзөт: «Жарыялар» (жабык) жана «Талкуу» темалары, '
    + 'бот-админ, өтүнмө боюнча кирүү. Группалар учурдагы Telegram-аккаунттун атынан түзүлүп, '
    + 'анын чат тизмесинде пайда болот.',
  'Создаём…': 'Түзүп жатабыз…',
  Синхронизировать: 'Синхрондоштуруу',
  Открыть: 'Ачуу',
  'Созданные сообщества': 'Түзүлгөн коомчулуктар',

  // Spaces drain notes/toasts (drainEngine / publishDrain)
  'Очередь пуста — все пространства созданы.': 'Кезек бош — бардык мейкиндиктер түзүлгөн.',
  'Telegram просит подождать {sec} с — попробуйте позже.':
    'Telegram {sec} секунд күтүүнү суранат — кийинчерээк аракет кылыңыз.',
  'Готово: {done} создано, {failed} с ошибкой.': 'Даяр: {done} түзүлдү, {failed} ката менен.',
  'Готово: {done} создано.': 'Даяр: {done} түзүлдү.',
  'Не удалось получить очередь: {message}': 'Кезекти алуу мүмкүн болгон жок: {message}',
  'Создаём пространство курса…': 'Курс мейкиндигин түзүп жатабыз…',
  // Showroom drain (showroomDrain / publishDrain) — the org's public storefront forum
  'Создаём витрину школы…': 'Мектептин витринасын түзүп жатабыз…',
  'Витрина школы создана: @{username}': 'Мектептин витринасы түзүлдү: @{username}',
  'Витрина школы создана.': 'Мектептин витринасы түзүлдү.',
  'Витрина школы: {done} создано, {failed} с ошибкой.':
    'Мектеп витринасы: {done} түзүлдү, {failed} ката менен.',

  // Media pick card (MediaPickCard)
  'Использовать это видео': 'Бул видеону колдонуу',
  'Использовать этот PDF': 'Бул PDF файлын колдонуу',
  'Использовать это фото': 'Бул сүрөттү колдонуу',
  Предпросмотр: 'Алдын ала көрүү',
  Загрузка: 'Жүктөлүүдө',
  'Выбрать другое': 'Башкасын тандоо',

  // Rich text editor (RichTextEditor / toolbarCommands)
  Форматирование: 'Форматтоо',
  Жирный: 'Калың',
  Заголовок: 'Аталыш',
  Подзаголовок: 'Кичи аталыш',
  Список: 'Тизме',
  'Нумерованный список': 'Номерленген тизме',

  // Video player (BileliVideoPlayer)
  Воспроизвести: 'Ойнотуу',
  'Включить звук': 'Үндү күйгүзүү',
  'Без звука': 'Үнсүз',
  Качество: 'Сапат',
  'Выйти из полноэкранного режима': 'Толук экрандан чыгуу',
  'На весь экран': 'Толук экран',

  // Date-time field (DateTimeField)
  Пн: 'Дш',
  Вт: 'Ше',
  Ср: 'Ша',
  Чт: 'Бш',
  Пт: 'Жм',
  Сб: 'Иш',
  Вс: 'Жш',
  Час: 'Саат',
  Мин: 'Мүн',
  Очистить: 'Тазалоо',
  Готово: 'Даяр',
  'Выберите дату': 'Күндү тандаңыз',
  'Предыдущий месяц': 'Мурунку ай',
  'Следующий месяц': 'Кийинки ай',

  // Legacy left-column catalog (CoursesPanel)
  Назад: 'Артка',

  // Sign-in failure states (TeachList gate / CourseDetail CTA note)
  Повторить: 'Кайталоо',
  'Слишком много попыток входа. Подождите несколько минут и попробуйте снова.':
    'Кирүү аракеттери өтө көп. Бир нече мүнөт күтүп, кайра аракет кылыңыз.',

  // Live call: managed mode (GroupCall) + the in-call message overlay (CallMessagesOverlay/CallSettingsGear)
  'Заглушить всех': 'Баарын үнсүз кылуу',
  'Снять режим тишины': 'Тынчтык режимин алып салуу',
  'Сообщения в эфире': 'Эфирдеги билдирүүлөр',
  'Реакции и сообщения участников поверх звонка.': 'Катышуучулардын реакциялары жана билдирүүлөрү чалуунун үстүндө.',
  'Написать в эфир…': 'Эфирге жазуу…',
  Отправить: 'Жөнөтүү',
  Удалить: 'Өчүрүү',
  'Удалить все сообщения участника': 'Катышуучунун бардык билдирүүлөрүн өчүрүү',
  'препод.': 'мугалим',

  // Live call: leaving vs ENDING the stream, and the hide (collapse) button (GroupCall)
  'Завершить эфир?': 'Эфирди аяктайсызбы?',
  'Завершить эфир': 'Эфирди аяктоо',
  '«Завершить эфир» отключит всех участников. «Выйти» — вы покинете звонок, эфир продолжится.':
    '«Эфирди аяктоо» бардык катышуучуларды өчүрөт. «Чыгуу» — сиз чалуудан чыгасыз, эфир уланат.',
  Выйти: 'Чыгуу',
  Свернуть: 'Жыйноо',
};
